import { type FormEvent, type ReactElement, useState } from 'react';
import { Button, FormField } from '@/shared/ui';
import { useUpdateProfile } from '../model/use-update-profile';

interface ProfileNameFormProps {
  /** 지금 이름 — 입력의 처음 값. */
  readonly initialName: string;
}

const NAME_MAX_LENGTH = 50;

/** 이름 변경 폼 — 저장되면 같은 자리에 완료 문구를 띄운다. 본인인증 전 계정은 서버가 거부하고 그 사유를 보여 준다. */
export const ProfileNameForm = ({ initialName }: ProfileNameFormProps): ReactElement => {
  const [name, setName] = useState(initialName);
  const { nameError, formError, isPending, isSaved, submit } = useUpdateProfile();

  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    void submit(name);
  };

  return (
    <form
      aria-label="이름 변경"
      onSubmit={handleSubmit}
      noValidate
      className="flex flex-col gap-3 sm:flex-row sm:items-end"
    >
      <FormField
        label="이름"
        autoComplete="name"
        isRequired
        maxLength={NAME_MAX_LENGTH}
        value={name}
        error={nameError ?? undefined}
        onChange={(event) => setName(event.target.value)}
        containerClassName="flex-1"
      />
      <Button
        type="submit"
        size="lg"
        isLoading={isPending}
        disabled={name.trim() === initialName.trim()}
        className="h-10 shrink-0 px-8"
      >
        저장
      </Button>
      {formError ? (
        <p role="alert" className="text-sm text-destructive sm:basis-full">
          {formError}
        </p>
      ) : null}
      {isSaved ? (
        <p role="status" className="text-sm text-muted-foreground sm:basis-full">
          이름을 저장했습니다.
        </p>
      ) : null}
    </form>
  );
};
